import axios, { AxiosResponse } from 'axios'

import { IActiviteitDetailsMetLesId } from '@/interfaces/IActiviteitDetails'
import { IAfspraakPost, IAfspraakPut, IIngeplandeItemsSearchRequest, IIngeplandeItemsSearchResponse, ILesMovePost, ILesReeksMovePost, IPlanItem, IPlanItemIngepland, IPlanItemPost, IUpdateRepeatableAfspraak } from './../interfaces/IPlanning'

export default class PlanningService {
    calculatePlanning(groepId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/Calculate/${groepId}`)
    }
    calculatePlanningLes(groepId: number, activiteitId: number, lesId: number, templateId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/Calculate/${groepId}/${activiteitId}/${lesId}/${templateId}`)
    }
    calculatePlanningLesAction(actie: number, groepId: number, activiteitId: number, lesId: number | null, templateId: number | null) {
        return axios.get(`/api/Frontend/Jaarplanning/Calculate/${actie}/${groepId}/${activiteitId}`, {
            params: {
                lesId: lesId,
                lesPlanningTemplateId: templateId,
            },
        })
    }
    getMethodeblokken(groepId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/methodeBLokken/${groepId}`)
    }
    getTemplatesEnLessen(groepId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/Afspraken/TemplatesAndLessen/${groepId}`)
    }
    getPlanning(groepId: number, begin?: string, eind?: string, includeRepeatDates?: boolean) {
        return axios.get(`/api/Frontend/Jaarplanning/${groepId}`, {
            params: {
                begin: begin ? begin : undefined,
                eind: eind ? eind : undefined,
                includeRepeatDates: includeRepeatDates !== undefined ? includeRepeatDates : undefined,
            },
        })
    }
    getSchoolweken() {
        return axios.get(`/api/Frontend/Jaarplanning/Schoolweken`)
    }
    getIngeplandeItems(groepId: number, begin?: string, eind?: string) {
        return axios.get(`/api/Frontend/Jaarplanning/IngeplandeItems/${groepId}`, {
            params: {
                begin: begin ? begin : undefined,
                eind: eind ? eind : undefined,
            },
        })
    }
    getActiviteitDetails(activiteitId: number, stamgroepId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/GetActiviteitDetails/${activiteitId}/${stamgroepId}`)
    }
    async getActiviteitDetailsList(activiteitIds: number[], stamgroepId: number): Promise<IActiviteitDetailsMetLesId[]> {
        const response = await axios.get(`/api/Frontend/Jaarplanning/ActiviteitDetailsList/${stamgroepId}`, {
            params: {
                lesIds: activiteitIds,
            },
            paramsSerializer: {
                indexes: null,
            },
        })

        return response.data
    }
    getLabelColors() {
        return axios.get(`/api/Frontend/Labels/Vakgebieden/kleuren`)
    }
    postPlanItem(groepId: number, jaargroepId: number, planitemId: number, payload: IPlanItemPost) {
        return axios.post(`/api/Frontend/Jaarplanning/${groepId}/${jaargroepId}/${planitemId}`, payload)
    }
    postEnkelelesDoorschuiven(payload: ILesMovePost) {
        return axios.post(`/api/Frontend/Jaarplanning/EnkeleLesDoorschuiven`, payload)
    }
    postLesreeksDoorschuiven(payload: ILesReeksMovePost) {
        return axios.post(`/api/Frontend/Jaarplanning/LesreeksDoorschuiven`, payload)
    }
    postPlanItemCorrigeren(stamgroepId: string, ingeplandeActiviteitId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/LatenVervallenEnAlsEerstvolgendeInplannen/${stamgroepId}/${ingeplandeActiviteitId}`)
    }
    postAfspraak(groepId: number, payload: IAfspraakPost): Promise<AxiosResponse<IPlanItemIngepland>> {
        const formData = new FormData()
        Object.keys(payload).forEach((key) => {
            let value = (payload as any)[key]
            value === null ? (value = '') : null
            formData.append(key, value)
        })
        return axios.post(`/api/Frontend/Jaarplanning/Afspraken/${groepId}`, formData)
    }
    putAfspraak(groepId: number, payload: IAfspraakPut) {
        const formData = new FormData()
        Object.keys(payload).forEach((key) => {
            let value = (payload as any)[key]
            value === null ? (value = '') : null
            formData.append(key, value)
        })
        return axios.put(`/api/Frontend/Jaarplanning/Afspraken/${groepId}`, formData)
    }
    putRepeatableAfspraak(id: number, data: IUpdateRepeatableAfspraak) {
        return axios.put(`/api/Frontend/Jaarplanning/Afspraken/repeatable/${id}`, data)
    }
    deleteLes(groepId: number, lesId: number) {
        return axios.delete(`/api/Frontend/Jaarplanning/${groepId}/${lesId}`)
    }
    methodeAfbeelding(methodeId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/Afspraken/MethodeAfbeelding/${methodeId}`).then((data) => data.data)
    }
    deleteAfspraak(groepId: number, afspraakId: number) {
        return axios.delete(`/api/Frontend/Jaarplanning/Afspraken/${groepId}/${afspraakId}`)
    }
    deleteAfspraakAfbeelding(groepId: number, afspraakId: number) {
        return axios.delete(`/api/Frontend/Jaarplanning/Afspraken/${groepId}/${afspraakId}/afbeelding`)
    }
    getLabelsMetNotities(stamgroepId: number) {
        return axios.get(`/api/Frontend/Planning/${stamgroepId}/notities/vakgerelateerd`)
    }
    getVakgebiedenVoorStamgroep(stamgroepId: number): Promise<AxiosResponse<number[]>> {
        return axios.get(`/api/Frontend/Jaarplanning/${stamgroepId}/vakgebieden`)
    }
    getLessenVoorVakgebied(stamgroepId: number, vakLabelId: number): Promise<AxiosResponse<IPlanItem[]>> {
        return axios.get(`/api/Frontend/Jaarplanning/${stamgroepId}/vakgebieden/${vakLabelId}`)
    }
    getToekomstigeLessenVoorVak(stamgroepId: number, vakId: number): Promise<AxiosResponse<IPlanItem[]>> {
        return axios.get(`/api/Frontend/Jaarplanning/${stamgroepId}/toekomst/${vakId}`)
    }
    getToekomstigeLessenVoorVakSearch(request: IIngeplandeItemsSearchRequest): Promise<AxiosResponse<IIngeplandeItemsSearchResponse>> {
        return axios.post(`/api/Frontend/Jaarplanning/toekomstsearch`, request)
    }
    postRepeatable(payload: any) {
        return axios.post(`/api/Frontend/Jaarplanning/Repeatable`, payload)
    }
    putRepeatable(id: number, payload: any) {
        return axios.put(`/api/Frontend/Jaarplanning/Repeatable/${id}`, payload)
    }
    getRepeatableDates(repeatGroupId: number, stamgroepId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/Repeatable/${repeatGroupId}/dates/${stamgroepId}`)
    }
    deleteRepeatableFuture(repeatGroupId: number, stamgroepId: number) {
        return axios.delete(`/api/Frontend/Jaarplanning/Repeatable/${repeatGroupId}/future/${stamgroepId}`)
    }
    postRepeatableAfspraak(payload: any) {
        return axios.post(`/api/frontend/Jaarplanning/Afspraken/Repeatable`, payload)
    }
    getRepeatableAfspraakDates(repeatGroupId: number, stamgroepId: number) {
        return axios.get(`/api/frontend/Jaarplanning/Afspraken/Repeatable/${repeatGroupId}/dates/${stamgroepId}`)
    }
    deleteRepeatableAfspraakFuture(repeatGroupId: number, stamgroepId: number, fromDate?: string) {
        const params = fromDate ? { fromDate } : {}
        return axios.delete(`/api/frontend/Jaarplanning/Afspraken/Repeatable/${repeatGroupId}/future/${stamgroepId}`, { params })
    }
    herstelVervallen(lesId: number, stamgroepId: number) {
        return axios.post(`/api/Frontend/Jaarplanning/HerstelVervallen/${lesId}/${stamgroepId}`)
    }
    zetLesTerugEnPlanReeksAan(stamgroepId: number, ingeplandeActiviteitId: number) {
        return axios.get(`/api/Frontend/Jaarplanning/ZetLesTerugEnPlanReeksAan/${stamgroepId}/${ingeplandeActiviteitId}`)
    }
}

export const planningService = new PlanningService()
